import coreModule from 'rhino/src/core/core.module';
import * as rnOrganization from './organization.service.js';

export default angular.module('rhino.components.organization', [coreModule])
  .factory(rnOrganization.name, rnOrganization.default)
  .name;




// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/organization/organization.module.js